import Approval from "@/api/Approval";

export const approval = {
    state: () => ({
    }),
    mutations: {
    },
    getters: {
    },
    actions: {
        async approvePD(params, id) {
            return new Promise((resolve, reject) => {
                Approval.approve(id)
                    .then(response => {
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            });
        },
    }
}